import { useMemo } from 'react';

import { getFirstDayOfCurrentMonth } from '@lib/util/date';
import { useConfirm, type UseConfirmOptions } from './use-confirm';

/**
 * Payment confirm hook for deposit/monthly settlement confirmation
 *
 * Business Rule:
 * - Users must confirm their deposit balance at the start of each month
 * - The dateToCheck is always the first day of the current month
 * - If lastConfirmedAt is before the first day of current month, show modal
 */
export const usePaymentConfirm = (
  options: Omit<UseConfirmOptions, 'storageKey'>
) => {
  const defaultDateToCheck = useMemo(() => getFirstDayOfCurrentMonth(), []);

  return useConfirm({
    ...options,
    dateToCheck: options.dateToCheck ?? defaultDateToCheck,
    storageKey: 'payment_confirm',
  });
};
